var formatters, outcomeCellTypes, viewHelperUtils, _getControlAttrs;

formatters = require('lib/formatters').outcome;

viewHelperUtils = require('lib/view_helper_utils');

outcomeCellTypes = require('models/outcome/outcome_cell_types');

_getControlAttrs = function(controlType) {
  var label, value;
  value = _(outcomeCellTypes['control'].otherFormatters).findWhere({
    contentDefaultClass: "" + controlType + "-value"
  }).footnotesAttrs.common;
  label = _(outcomeCellTypes['control'].otherFormatters).findWhere({
    contentDefaultClass: "" + controlType + "-value-label"
  }).footnotesAttrs.common;
  return label.concat(value);
};

module.exports = {
  theadSchemas: {
    'sof_regular': [
      {
        'outcome': [2, 1],
        'absoluteEffect': [1, 2],
        'relativeEffect': [2, 1],
        'noOfParticipants': [2, 1],
        'quality': [2, 1],
        'comments': [2, 1]
      }, {
        'riskWith[comparison]': [1, 1],
        'riskWith[intervention]': [1, 1]
      }
    ],
    'sof_narrative': [
      {
        'outcome': [1, 1],
        'impact': [1, 1],
        'noOfParticipants': [1, 1],
        'quality': [1, 1]
      }
    ],
    'accp_sof_regular': [
      {
        'outcome': [2, 1],
        'noOfParticipantsFollowUp': [2, 1],
        'quality': [2, 1],
        'relativeEffect': [2, 1],
        'absoluteEffect': [1, 2]
      }, {
        'riskWith[comparison]': [1, 1],
        'riksDifferenceWith[intervention]': [1, 1]
      }
    ],
    'accp_sof_narrative': [
      {
        'outcome': [1, 1],
        'noOfParticipantsFollowUp': [1, 1],
        'quality': [1, 1],
        'impact': [1, 1]
      }
    ],
    'sof_v3_regular': [
      {
        'outcome': [2, 1],
        'relativeEffect': [2, 1],
        'absoluteEffect': [1, 3],
        'quality': [2, 1],
        'whatHappens': [2, 1]
      }, {
        'without[intervention]': [1, 1],
        'with[intervention]': [1, 1],
        'difference': [1, 1]
      }
    ],
    'sof_v3_narrative': [
      {
        'outcome': [1, 1],
        'impact': [1, 1],
        'quality': [1, 1]
      }
    ]
  },
  theadLabels: {
    outcome: $.t('es:outcomes'),
    impact: $.t('es:outcome.impact'),
    riskWith: $.t('es:outcome.risk_with'),
    riksDifferenceWith: $.t('es:outcome.risk_difference_with'),
    absoluteEffect: "" + ($.t('es:outcome.anticipated_absolute_effects')) + "<SUP>*</SUP> (95% CI)",
    relativeEffect: "" + ($.t('es:outcome.relative_effect')) + "<BR />(95% CI)",
    noOfParticipants: "" + ($.t('es:outcome.no_of_participants')) + "<BR />(" + ($.t('es:outcome.studies')) + ")",
    noOfParticipantsFollowUp: "" + ($.t('es:outcome.no_of_participants')) + "<BR /> (" + ($.t('es:outcome.studies')) + ")<BR />" + ($.t('es:outcome.follow_up')),
    quality: "" + ($.t('es:outcome.quality_of_evidence')) + "<BR />(GRADE)",
    comments: $.t('es:outcome.comments'),
    whatHappens: $.t('es:outcome.what_happens'),
    assumedRisk: $.t('es:outcome.assumed_risk'),
    "with": $.t('es:outcome.with'),
    without: $.t('es:outcome.without'),
    difference: $.t('es:outcome.difference')
  },
  tbodyCells: {
    'outcome': function(attributes) {
      return formatters.label.call(formatters, attributes, attributes.tableView);
    },
    'contSofControl': function(attributes) {
      var viewType;
      viewType = attributes.tableView;
      if (attributes.metaType === 'NOT_POOLED' && attributes.tableView === 'sof') {
        return $.t('es:outcome.not_estimable');
      } else {
        return formatters.sofControl.call(formatters, _(attributes).extend({
          _viewTypeName: viewType
        }));
      }
    },
    'contCorrespondingRisk': function(attributes) {
      if (attributes.tableView === 'sof_v3') {
        return '-';
      } else {
        return formatters._contCorrespondingRisk.call(formatters, attributes);
      }
    },
    'contRiskDifference': function(attributes) {
      if (attributes.metaType === 'NOT_POOLED') {
        return $.t('es:outcome.not_estimable');
      } else {
        return formatters.riskDifference.call(formatters, attributes);
      }
    },
    'relativeEffect': formatters.relativeEffect.bind(formatters),
    'noOfParticipants': formatters.noOfParticipantsStudies.bind(formatters),
    'noOfParticipantsFollowUp': formatters.noOfParticipantsStudiesFollowUp.bind(formatters),
    'quality': function(attributes) {
      var _ref;
      if ((_ref = attributes.metaType) === 'NOT_MEASURED' || _ref === 'NOT_REPORTED') {
        return '-';
      } else {
        _(attributes).extend({
          rm5export: true
        });
        return formatters.quality.call(formatters, attributes);
      }
    },
    'comments': function(attributes) {
      return attributes.comments || '';
    },
    'whatHappens': function(attributes) {
      return attributes.comments || '';
    },
    'impact': function(attributes) {
      return attributes.narrativeDesc || '';
    },
    'dichNotReportedSofControl': function() {
      return $.t('es:outcome.see_comment');
    },
    'dichNotReportedCorrespondingRisk': function() {
      return $.t('es:outcome.see_comment');
    },
    'dichNotReportedRiskDifference': function() {
      return $.t('es:outcome.see_comment');
    },
    'controlLabel': function(controlRisk) {
      if (controlRisk === 'calculatedControl') {
        return $.t('es:outcome.printout.study_population');
      } else {
        return $.t('es:outcome.' + _.str.underscored(controlRisk + 'Label'));
      }
    },
    'dichSofControl': function(attributes, controlRisk) {
      var formatter, viewType;
      if (attributes.metaType === "NOT_POOLED") {
        return $.t('es:outcome.not_pooled');
      } else {
        viewType = attributes.tableView;
        formatter = controlRisk === 'calculatedControl' ? 'control' : "" + controlRisk + "Risk";
        return formatters[formatter].call(formatters, _(attributes).extend({
          _viewTypeName: viewType
        }));
      }
    },
    'dichCorrespondingRisk': function(attributes, controlRisk) {
      var formatter, riskSuffix, viewType;
      if (attributes.metaType === "NOT_POOLED") {
        return $.t('es:outcome.not_pooled');
      } else {
        viewType = attributes.tableView;
        riskSuffix = viewHelperUtils.controlRiskFormatterSuffix(controlRisk);
        formatter = "correspondingRisk" + riskSuffix;
        return formatters[formatter].call(formatters, _(attributes).extend({
          _viewTypeName: viewType
        }));
      }
    },
    'dichRiskDifference': function(attributes, controlRisk) {
      var formatter, riskSuffix, viewType;
      viewType = attributes.tableView;
      riskSuffix = viewHelperUtils.controlRiskFormatterSuffix(controlRisk);
      formatter = "riskDifference" + riskSuffix;
      return formatters[formatter].call(formatters, _(attributes).extend({
        _viewTypeName: viewType
      }));
    }
  },
  tableCaptionSchemas: {
    'sof': ['title', 'sofMeta'],
    'accp_sof': ['title', 'accp_sofMeta'],
    'sof_v3': ['title', 'sofMeta']
  },
  tableCaptionCells: {
    'title': function(attributes) {
      return "<B>" + attributes.title + "</B>";
    },
    'sofMeta': function(attributes) {
      return "<B>" + ($.t('es:outcome.printout.patient_or_population')) + ": </B>" + attributes.hpOrPop + " <BR /> <B>" + ($.t('es:question.setting')) + ": </B>" + attributes.settings + " <BR /> <B>" + ($.t('es:outcome.intervention')) + ": </B>" + attributes.intervention + " <BR /> <B>" + ($.t('es:outcome.comparison')) + ": </B>" + attributes.comparison;
    },
    'accp_sofMeta': function(attributes) {
      return "<B>" + ($.t('es:question.bibliography')) + ": " + attributes.bibliography + "</B>";
    }
  },
  attributesMap: {
    'outcome': outcomeCellTypes['sofOutcomeLabel'].footnotesAttrs.common,
    'dichSofControl': ['controlCount', 'controlTotal'],
    'dichSofControlLow': _getControlAttrs('low'),
    'dichSofControlModerate': _getControlAttrs('moderate'),
    'dichSofControlHigh': _getControlAttrs('high'),
    'contSofControl': ['changeScoreInControlsValue', 'units'],
    'dichCorrespondingRisk': ['interventionCount', 'interventionTotal'],
    'contCorrespondingRisk': ['effectMeasure', 'effectSize', 'confidenceIntervalFrom', 'confidenceIntervalTo'],
    'relativeEffect': outcomeCellTypes['relativeEffect'].footnotesAttrs.common,
    'noOfParticipants': outcomeCellTypes['noOfParticipantsStudies'].formatterAttrsObserve,
    'noOfParticipantsFollowUp': outcomeCellTypes['noOfParticipantsStudiesFollowUp'].formatterAttrsObserve,
    'quality': outcomeCellTypes['quality'].footnotesAttrs.SOF,
    'comments': ['comments'],
    'whatHappens': ['comments'],
    'impact': ['narrativeDesc']
  },
  Rm5ExportTableCell: (function() {
    function _Class(params) {
      var key, value;
      if (params == null) {
        params = {};
      }
      for (key in params) {
        value = params[key];
        this[key] = value;
      }
    }

    _Class.prototype.type = 'td';

    _Class.prototype.textContent = '';

    _Class.prototype.rowspan = 1;

    _Class.prototype.colspan = 1;

    _Class.prototype.align = 'LEFT';

    _Class.prototype.valign = 'TOP';

    _Class.prototype.sup = '';

    return _Class;

  })()
};
